import type { DeepReadonly } from 'vue';

import type { GraphQL, Pax } from '@libs/trip-planner-interfaces';

export function getInputPaxGroupQL(
  pax: DeepReadonly<Pax>
): GraphQL.InputPaxGroupQL[] {
  return pax.map((room) => ({
    numberOfAdults: room.numberOfAdults,
    childAges: [...(room.childAges ?? [])],
  }));
}
